import React from 'react';
import { Section } from './Section';
import { Heart } from 'lucide-react';
export function PainAgitation() {
  const pains = ['Tu cuerpo ya no es tuyo', 'La hinchazón y el cansancio no desaparecen', 'No tienes energía para nada más allá de sobrevivir el día', 'Te sientes culpable por no estar "bien" cuando deberías estar feliz', 'Perdiste el hilo de quién eras antes de ser mamá', 'Nadie entiende realmente lo que estás viviendo'];
  return <Section data-id="element-153">
      <div className="max-w-3xl mx-auto" data-id="element-154">
        <h2 className="text-3xl md:text-4xl text-center mb-10" data-id="element-155">
          Nadie te preparó para esto.
        </h2>

        <div className="space-y-6 text-lg text-brown-light mb-12" data-id="element-156">
          <p data-id="element-157">
            Para las noches sin dormir que se convierten en semanas. Para
            sentirte hinchada, inflamada y desconectada de tu propio cuerpo.
            Para esa niebla mental que no te deja pensar con claridad.
          </p>
          <p data-id="element-158">
            Para el momento en que alguien te pregunta "¿cómo estás tú?" y no
            sabes qué responder porque hace tanto tiempo que nadie te lo
            preguntaba que casi olvidaste que tú también importas.
          </p>
        </div>

        <div className="bg-white/50 rounded-2xl p-8 md:p-10 shadow-sm border border-rose/10 mb-12" data-id="element-159">
          <h3 className="text-xl font-medium mb-6 text-center" data-id="element-160">
            Tal vez sientes que:
          </h3>
          <ul className="space-y-4" data-id="element-161">
            {pains.map((pain, index) => <li key={index} className="flex items-start gap-4" data-id="element-162">
                <Heart className="w-5 h-5 text-rose mt-1 flex-shrink-0 fill-rose/20" data-id="element-163" />
                <span className="text-lg" data-id="element-164">{pain}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center space-y-4" data-id="element-165">
          <p className="text-lg mb-6" data-id="element-166">Y en silencio te preguntas:</p>
          <p className="font-script text-3xl md:text-4xl text-rose-dark" data-id="element-167">
            ¿Seré siempre así?
          </p>
          <p className="font-script text-3xl md:text-4xl text-rose-dark" data-id="element-168">
            ¿Esto es normal o algo está mal conmigo?
          </p>
          <p className="font-script text-3xl md:text-4xl text-rose-dark" data-id="element-169">
            ¿Volveré a sentirme yo de verdad?
          </p>

          <div className="mt-12 pt-8 border-t border-rose/20" data-id="element-170">
            <p className="text-2xl font-serif text-brown-dark" data-id="element-171">
              La respuesta es <span className="italic text-rose" data-id="element-172">sí</span>. Y
              estás a punto de descubrir exactamente cómo.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}